// Legacy triage-board URL — the board moved to the unified Inbox at
// `/inbox/board` in the 2026-07 nav review. Redirect preserves the full
// search-param state (filters, q, runId) so bookmarked filtered views land
// on the identical board state. `replace: true` keeps the back button from
// getting stuck on the redirecting URL.
//
// A bookmark carrying the retired `?mode=status` (DEV-17093) is normalized
// here for free: `parseTriageSearch` whitelists known keys, so the param is
// dropped on the way through and the user lands on the one board with the
// rest of their filters intact.
import { createFileRoute, redirect } from '@tanstack/react-router';

import { parseTriageSearch } from '../../../components/runs/triage-helpers';
import { routes } from '../../../lib/constants';

export const Route = createFileRoute('/triage/runs/')({
  validateSearch: parseTriageSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: routes.INBOX_BOARD, search, replace: true });
  },
  // Component never renders — the redirect fires in `beforeLoad`.
  component: () => null,
});
